/**
 * @generated SignedSource<<14b2210cef80facaba6e3913b8aac41d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoListItemCompletedInfo_todo$data = {
  readonly lastChangedStatusByActor: {
    readonly " $fragmentSpreads": FragmentRefs<"Avatar_actor">;
  } | null;
  readonly resolvedAtDate: {
    readonly " $fragmentSpreads": FragmentRefs<"StoreFormattedDate">;
  } | null;
  readonly " $fragmentType": "TodoListItemCompletedInfo_todo";
};
export type TodoListItemCompletedInfo_todo$key = {
  readonly " $data"?: TodoListItemCompletedInfo_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoListItemCompletedInfo_todo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoListItemCompletedInfo_todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreZonedDate",
      "kind": "LinkedField",
      "name": "resolvedAtDate",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "StoreFormattedDate"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "lastChangedStatusByActor",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Avatar_actor"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};

(node as any).hash = "1b8b53a31658ea4de85447308fcd053b";

export default node;
